import React from 'react';
import { Field } from 'formik';
import { Row } from 'react-bootstrap';
import { CustomSelectComponent, FieldInput, FormCol, FormFilterCard } from 'motion-components';
import { useTranslation } from 'react-i18next';
import { notificationRecipientStatusOptions } from '../constants';

export function buildRecipientsWhereFromFilterValues(values): string {
  const where: any = {};
  if (values?.notificationId) where.notificationId = values.notificationId;
  if (values?.searchText) {
    const likeObj = { $like: '%' + values.searchText + '%' };
    where.$or = [
      { email: likeObj },
      { '$collectionpoint.name$': likeObj },
      { '$collectionpoint.addressCity$': likeObj },
    ];
  }
  if (values?.statusId !== undefined && values?.statusId !== null && values?.statusId !== '') {
    where.statusId = Number(values.statusId);
  }
  return JSON.stringify(where);
}

export const RecipientsFilters = ({ onChange, initialValues, disable = false }) => {
  const { t } = useTranslation();

  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setSubmitting(false);
    onChange(values);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    statusId: initialValues?.statusId ?? null,
  };

  return (
    <FormFilterCard
      title={t('Φίλτρο παραληπτών')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση (σημείο, email, πόλη)')}
          type="search"
          disable={disable}
        />
        <FormCol>
          {/* as="div": το CustomSelect βάζει από μόνο του FormCol και θα στένευε */}
          <Field
            as="div"
            className="mb-2"
            name="statusId"
            title={t('Κατάσταση')}
            component={(props) => <CustomSelectComponent {...props} as="div" />}
            options={notificationRecipientStatusOptions.map((o) => ({
              value: o.value,
              label: t(o.label),
            }))}
            disabled={disable}
          />
        </FormCol>
      </Row>
    </FormFilterCard>
  );
};
